<template>
    <v-container fluid>
        <v-layout row class="head-menu">
            <v-toolbar flat fixed>
                <v-toolbar-side-icon><img src="../assets/logo.svg" alt="logo" class="logo-toolbar"></v-toolbar-side-icon>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                <v-btn flat class="menu-content">A Propos</v-btn>
                <v-btn flat class="menu-content">Contact</v-btn>
                <v-btn 
                href ="https://goo.gl/NNw2AC"
                flat
                class="menu-content"
                >
                <span class="download-app">Télécharger goMediCAL</span>
                </v-btn>
                </v-toolbar-items>
            </v-toolbar>
        </v-layout>
        <v-divider class="divider-menu"/>
        <v-layout row wrap class="home-wrapper">
            <v-flex xs6>
                <left-block/>
            </v-flex>
            <v-flex xs6 justify-center>
                <right-block 
                class="lg-right-side"
                @good-code="validateCode"/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import LeftBlock from './Left'
import RightBlock from './Right'
export default {
    components: {
        LeftBlock,
        RightBlock
    },

    methods: {
        validateCode () {
            this.$emit ('good-code')
        }
    }
}
</script>

<style>
/* .logo {
    margin-left: 5em;
} */

.container {
    padding: 0px !important
}
.home-wrapper {
    width: 100vw;
}
.head-menu {
    background-color: #ffffff00 !important;
    margin-bottom: 48px;
}
.logo-toolbar {
   margin-top: -0.5em;
   margin-left: -0.2em;
}

.divider-menu {
    margin-bottom: 35px
}
.lg-right-side {
    margin: 0 auto;
    width: 436px;
    /* box-shadow: 1px -5px 66px -22px #888888; */
}
.lg-right-side .responsive-page {
    height: auto;
    width: 100%;
    background-size: 100%;
    background-color: #EFF6F9;
}

.lg-right-side .payment-div {
    margin-top: 2rem;
}
.v-toolbar__content>:first-child.v-btn--icon {
    margin-left: 74px !important;
}
.menu-content {
    text-transform: none !important;
    color: #808080 !important;
    font-weight: bold;
}
.download-app {
    border-radius: 30px;
    border: 1px solid #2BA359;
    background: #2BA359;
    color: #fff;
    padding: 10px 20px;
    text-transform: none;
}
.v-toolbar__content {
    background: #fff !important;
    border-bottom: 1px solid #E5E5E5 !important;
}
</style>
